import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import FavoriteTestsResponse from "../../../models/API/responseModels/onlineOrderResponseModels/favoriteTestsResponse.model";

function useFavoriteTestLists(): UseQueryResult<FavoriteTestsResponse> {
  const authState = useOktaAuth()?.authState;
  return useQuery({
    queryKey: ["favoriteTests"],
    queryFn: () =>
      axiosInstance
        .get("/v1/test-type/my-favorite-tests", {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data),
    enabled: !!authState?.accessToken,
  });
}

export default useFavoriteTestLists;
